<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Businesses</h1>
        </div>
        <div class="modal-body no-pad" v-if="business">
            <div class="flex h-full">
                <div class="business-sidebar h-full">
                    <div class="mb-4 text-center">
                        <p class="text-lg font-light">Business #{{ business.id }}</p>
                    </div>

                    <div class="mb-3">
                        <label>Account</label>
                        <p><a href="#" @click.prevent="closeView">{{ business.account_id }}</a></p>
                    </div>

                    <div class="mb-3" v-if="extractedKeywords && extractedKeywords.keywords.length > 0">
                        <tab-modal
                            label="Computed Keywords"
                            :tab-items="extractedKeywords.keywords"
                            description="These are the keywords that'll be used for matching">
                        </tab-modal>
                    </div>
                </div>
                <div class="business-body">
                    <div class="form-field">
                        <label>Business Name</label>
                        <input type="text" v-model="business.name" placeholder="Business Name">
                    </div>

                    <div class="form-field">
                        <label>Press Room Slug</label>
                        <input type="text" v-model="business.pressroom.shortname" placeholder="Press Room Slug">
                    </div>

                    <div class="form-field">
                        <label>Press Room Public</label>
                        <CheckBox v-model="business.pressroom.public" :val="business.pressroom.public" />
                    </div>

                    <tags-input-field
                        label="Keywords"
                        placeholder="Keywords"
                        input-name="keywords"
                        :data="profileKeywords"
                        @selected="handleKeywords">
                    </tags-input-field>

                    <div class="form-field">
                        <label>Sector</label>
                        <picker-selector
                            v-if="sectors && sectors.length > 0"
                            placeholder="Select Sectors"
                            v-model="profileSectors"
                            input-name="sectors[]"
                            @update:modelValue="addSectors"
                            :options="sectors">
                        </picker-selector>
                    </div>
                    <div class="form-field">
                        <label>Location</label>
                        <picker-selector
                            v-if="locations && locations.length > 0"
                            placeholder="Select Locations"
                            v-model="profileLocations"
                            input-name="locations[]"
                            @update:modelValue="addLocations"
                            :options="locations">
                        </picker-selector>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="flex">
                <div class="left text-left">
                    <ActionsBox>
                        <button class="btn-primary muted" type="button" @click="handleViewUsers">View Business Users</button>
                        <button class="btn-danger" type="button" @click="handleDelete">Delete</button>
                    </ActionsBox>
                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="handleBusinessUpdate">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ActionsBox from '../../ActionsBox'
    import TagsInputField from '../../TagsInputField'
    import {useStore} from "vuex"

    export default {
        name: 'BusinessesView',
        props: {},
        data() {
            return {
                business: null,
                profileSectors: null,
                profileLocations: null,
                profileKeywords: null,
                extractedKeywords: null,
            }
        },
        components: {
            TagsInputField,
            ActionsBox,
        },
        mounted() {
            this.loadData()
            this.setMetaTitle('Businesses Management | JournoLink Control')
        },
        methods: {
            loadData() {
                axios.get(route('businesses.show', this.$route.params.businessId))
                    .then(response => {
                        this.business = response.data.business
                        this.profileSectors = response.data.profileSectors
                        this.profileLocations = response.data.profileLocations
                        this.profileKeywords = response.data.profileKeywords
                        this.extractedKeywords = this.business && this.business.keyword
                    })
                    .catch(e => {
                        console.error({e})
                    })
            },
            /**
             * Emit the close event to the parent
             *
             * @return {void}
             */
            closeView() {
                this.setMetaTitle('Account Management | JournoLink Control')
                this.$root.goBack()
            },
            handleBusinessUpdate() {
                axios.post(route('businesses.update', this.$route.params.businessId), {
                    name: this.business.name,
                    shortname: this.business.pressroom.shortname,
                    public: this.business.pressroom.public ? 1 : 0,
                    sectors: this.profileSectors,
                    locations: this.profileLocations,
                    keywords: this.profileKeywords
                }).then(response => {
                    this.$bus.$emit('alert.success', 'Update Success')
                    this.loadData()
                }).catch(e => {
                    this.$bus.$emit('alert.danger', 'Update Failed')
                })
            },
            /**
             * Perform a request to delete the record.
             *
             * @return {void}
             */
            handleDelete() {
                this.alert.fire({
                    title: 'Confirm Delete',
                    text: 'Are you sure you want to delete this record?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, continue',
                    confirmButtonColor: '#e3342f',
                    cancelButtonText: 'No, go back'
                })
                    .then((selected) => {
                        if (selected.value) {
                            axios.delete(route('businesses.delete', this.$route.params.businessId))
                                .then(response => {
                                    this.$bus.$emit('alert.success', 'Deleted')
                                    this.closeView()
                                })
                                .catch(e => {
                                    console.error(e)
                                    this.$bus.$emit('alert.danger', 'Could not delete record')
                                })
                        }
                    })
            },
            addLocations(ids) {
                this.profileLocations = ids
            },
            addSectors(ids) {
                this.profileSectors = ids
            },
            /**
             * Handle an [Escape] keypress
             *
             * @return {void}
             */
            onEscapeKeypress() {
                this.closeView()
            },
            handleViewUsers() {
                this.$root.persist.usersSearch = "business:" + this.business.name
                this.$router.push({name: 'users.list'})
            },
            handleKeywords (keywords) {
                this.profileKeywords = keywords
            },
        },
        computed: {
            sectors () {
                const store = useStore()
                return store.state.sectors ?? []
            },
            locations () {
                const store = useStore()
                return store.state.locations ?? []
            },
        }
    }
</script>

<style lang="less">
    .business-sidebar {
        padding: 15px;
        width: 250px;
        font-size: 0.9rem;
        background: #f6f6f6;

        label {
            font-weight: bold;
            font-size: 0.8em;
            color: #999999;
        }

        p {
            margin-bottom: 0.5em;
        }
    }

    .business-body {
        flex: 1;
        padding: 15px;

        .brief {
            margin: 1em 0;
        }
    }
</style>
